import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerRightUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowCornerRightUp"><Path fillRule="evenodd" clipRule="evenodd" d="M15.25 2.68945L20.3107 7.75011L19.25 8.81077L16 5.56077V21.0001H4V19.5001H14.5V5.56077L11.25 8.81077L10.1893 7.75011L15.25 2.68945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerRightUp;
